module.exports = __webpack_public_path__ + "static/media/yi_chang_xj.d119d62a.mp3";